// About Us page content — bilingual
export const ABOUT = {
  founder: {
    heading_zh: '创办人 Soo Li Theng',
    heading_en: 'Founder: Soo Li Theng',
    body_zh:
      'Soo 是马来西亚华人、政府认证护士，拥有 15 年护理经验，也是国家认证讲师与泌乳辅导员。自 2021 年开始在月子中心从事母婴护理与泌乳咨询，2023 年 6 月创立自己的公司，提供上门泌乳咨询、无痛通乳、母婴课程和挤奶器相关服务。',
    body_en:
      'Soo is a Malaysian Chinese registered nurse with 15 years of nursing experience, a certified trainer, and a lactation peer counsellor. Since 2021, she has worked in confinement centre mother-baby care and lactation support. In June 2023, she started her own company providing home lactation consultation, painless lactation service, mother-baby education, and breast pump support.',
    image_url:
      'https://images.unsplash.com/photo-1584432810601-6c7f27d2362b?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
  },
  background: {
    heading_zh: '医疗背景 + 母婴护理经验',
    heading_en: 'Medical Background + Mother-Baby Care Experience',
    bullets_zh: [
      '政府认证护士，15 年护理经验',
      '国家认证讲师',
      '泌乳辅导员 Lactation Peer Counsellor',
      '2021 年开始接触月子中心母婴护理',
      '2023 年开始提供上门泌乳咨询与无痛通乳服务',
      '擅长处理涨奶、堵奶、小白点、乳腺炎 follow-up、亲喂指导、挤奶器与喇叭尺寸问题',
    ],
    bullets_en: [
      'Registered nurse with 15 years of nursing experience',
      'Certified trainer',
      'Lactation Peer Counsellor',
      'Mother-baby care experience in confinement centres since 2021',
      'Home lactation consultation and painless lactation service since 2023',
      'Experienced with engorgement, clogged ducts, milk blebs, mastitis follow-up, latch support, pump and flange issues',
    ],
  },
  centres: {
    heading_zh: '合作月子中心',
    heading_en: 'Confinement Centre Collaborations',
    body_zh:
      '我们目前与雪隆区 10 家以上月子中心合作，协助妈妈处理产后哺乳、涨奶、堵奶、亲喂、奶量和挤奶器相关问题。',
    body_en:
      'We collaborate with more than 10 confinement centres across KL/Selangor, supporting mothers with postpartum breastfeeding, engorgement, clogged ducts, direct latch, milk supply, and breast pump-related concerns.',
    list: [
      'LaBébé',
      'Serenity',
      'Amazing',
      '28 Goodday',
      'Virtuous Confinement',
      'Golden Moon',
      '55 Petals',
      'SY Postpartum',
      'Queensway Confinement',
      'and more',
    ],
  },
  media: {
    heading_zh: '课程、平台合作与媒体曝光',
    heading_en: 'Courses, Platform Collaborations & Media',
    body_zh:
      '除了个案咨询，我们也参与线下母婴课程、平台合作、电台访问和哺乳教育分享，把正确、实用、温柔的哺乳知识带给更多家庭。',
    body_en:
      'Beyond individual consultation, we also participate in offline mother-baby classes, platform collaborations, radio interviews, and breastfeeding education sharing to bring practical and supportive knowledge to more families.',
    gallery: [
      { label_zh: '线下母婴课程', label_en: 'Offline mother-baby class' },
      { label_zh: '平台合作', label_en: 'Platform collaboration' },
      { label_zh: '电台访问', label_en: 'Radio interview' },
      { label_zh: '月子中心课程', label_en: 'Confinement-centre class' },
    ],
  },
  technique: {
    heading_zh: '台湾式无痛泌乳手法',
    heading_en: 'Taiwan-Style Painless Lactation Approach',
    body_zh:
      '我们的服务以台湾式无痛泌乳理念为基础，强调轻柔、评估、顺着乳房组织状态处理，而不是传统强力硬推式按摩。每位妈妈的状况不同，我们会先了解产后天数、疼痛程度、奶量、亲喂/挤奶方式、是否有发烧红肿，再给予适合的处理方案。',
    body_en:
      'Our approach is based on Taiwan-style painless lactation principles. We focus on gentle assessment and working with the breast tissue condition, rather than forceful traditional massage. Every mother is different, so we first assess postpartum stage, pain level, milk output, feeding/pumping pattern, fever or redness, and then recommend a suitable care plan.',
  },
  comparison: {
    heading_zh: '我们和传统按摩有什么不同？',
    heading_en: 'How We Differ from Traditional Massage',
    col1_zh: '传统强力按摩',
    col1_en: 'Traditional Forceful Massage',
    col2_zh: 'You & Me 无痛泌乳',
    col2_en: 'You & Me Painless Lactation',
    rows: [
      {
        label_zh: '处理方式',
        label_en: 'Method',
        a_zh: '常以大力推按为主',
        a_en: 'Often relies on forceful pushing',
        b_zh: '先评估，再用轻柔方式协助奶流',
        b_en: 'Assess first, then use gentle techniques to support milk flow',
      },
      {
        label_zh: '疼痛感',
        label_en: 'Pain',
        a_zh: '可能很痛，妈妈容易害怕',
        a_en: 'Can be very painful and stressful',
        b_zh: '以降低疼痛和组织刺激为目标',
        b_en: 'Aims to reduce pain and tissue irritation',
      },
      {
        label_zh: '判断方式',
        label_en: 'Assessment',
        a_zh: '较依赖按摩经验',
        a_en: 'More experience-based',
        b_zh: '结合护理背景、哺乳评估和 red flag 筛查',
        b_en: 'Combines nursing background, lactation assessment, and red-flag screening',
      },
      {
        label_zh: '后续照护',
        label_en: 'Follow-up',
        a_zh: '可能只处理当下',
        a_en: 'May focus only on the current session',
        b_zh: '提供后续建议、手挤教学、泵奶和亲喂调整',
        b_en: 'Provides follow-up advice, hand expression guidance, pump and latch adjustment',
      },
    ],
  },
  why: {
    heading_zh: '为什么妈妈选择我们？',
    heading_en: 'Why Mothers Choose Us',
    bullets_zh: [
      '有专业护理背景，不只是按摩经验',
      '有真实月子中心母婴护理经验',
      '会先评估，不会一开始就大力按',
      '重视妈妈疼痛感和安全感',
      '结合亲喂、挤奶器、手挤、奶量和宝宝情况一起看',
      '有后续 follow-up 和 WhatsApp 支持',
      '可提供 video call、上门服务和一个月哺乳陪跑',
      '未来可由平台安排合适泌乳顾问，让妈妈有选择和更换顾问的权利',
    ],
    bullets_en: [
      'Medically trained nursing background, not just massage experience',
      'Real mother-baby care experience in confinement centres',
      'Assessment-first approach, not forceful treatment from the start',
      "Prioritises mother's comfort and sense of safety",
      'Looks at latch, pump, hand expression, milk output, and baby signs together',
      'Follow-up and WhatsApp support available',
      'Video call, home visit, and one-month breastfeeding coaching available',
      'Future consultant platform gives mothers more choice and the option to change consultant if needed',
    ],
  },
  cta: {
    heading_zh: '不确定自己是涨奶、堵奶、小白点还是挤奶器问题？',
    heading_en: 'Not sure whether it is engorgement, clogged duct, milk bleb, or pump issue?',
  },
};
